import { onlineManager } from "@tanstack/react-query";

import { makeCollectionQuery, type DojoCollectionPage, type CollectionQueryType } from "./collectionQuery";
import { makeMemberQuery, type MemberQueryType, type MemberQueryObserver } from "./memberQuery";
import { makeMutation, makeApiMutation, type OperationParams, type OperationResult } from "./mutation";
import { useReactiveLocalStorage } from "./reactiveLocalStorage";
import { APIResponse } from "./types";
export { USE_PRECANARY_STORAGE_KEY, isPrecanaryRequested } from "./precanary";
export { useMutation, useQuery, useInfiniteQuery } from "@tanstack/react-query";
export type { UseMutationOptions, Mutation } from "@tanstack/react-query";
onlineManager.setOnline(true);

// `Response` is the fetchers-layer response shape: a minimal, superagent-Response-compatible type
// (see @web-monorepo/infra's ApiResponseLike) that the fetch-based layer can produce without a cast.
export type { ApiResponseLike as Response } from "@web-monorepo/infra/responseHandlers";

export {
  makeMemberQuery,
  makeCollectionQuery,
  makeMutation,
  makeApiMutation,
  useReactiveLocalStorage,
  type DojoCollectionPage,
  type MemberQueryType,
  type MemberQueryObserver,
  type CollectionQueryType,
  type APIResponse,
};

export type {
  APIRequestBody,
  APIRequestParameters,
  MemberFetcherReturnType,
  CollectionFetcherReturnType,
  CollectionFetcherParamsType,
  EndpointParameters,
  EndpointPathParameters,
  EndpointQueryParameters,
  EndpointParams,
} from "./types";

export {
  makeApiErrorMessage,
  isApiError,
  FetchersAPIResponseError,
  NoNetworkError,
  InvalidCollectionResponseError,
  EmptyResponseBodyError,
  isNoNetworkError,
  isEmptyResponseBodyError,
  isRawNetworkError,
  isConnectivityError,
  isInvalidNameError,
  getInvalidNameErrorMessage,
  throwUnlessInvalidNameError,
  isUnexpectedMutationError,
  getApiErrorDetail,
} from "./error";
export type { ResponseError } from "./error";
export { isApiResponseError, type APIResponseError } from "@web-monorepo/infra/responseHandlers";
export { NOOP, WAITING_FOR_DEPENDENCIES, CUSTOM_HEADERS } from "./constants";
export { apiFetch } from "./apiFetch";
export { callApi, type CallApiReturnType } from "./callApi";
export type { CallApiParams, ApiResponse, Method, FetchResponse, ApiSuccess, ApiError } from "./apiFetch";

export type { OperationParams, OperationResult };

export { queryClient } from "./queryClient";
export { makeQueryKey } from "./queryKey";
export { ReactQueryDevTools, ReactQueryProvider } from "./provider";
export { useMutationStartCallback, useMutationSuccessCallback, useMutationErrorCallback } from "./mutationCache";
